var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolvedIcon,{tag:"component",staticClass:"app-lucide-icon",attrs:{"size":_vm.size,"stroke-width":_vm.strokeWidth,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }